import { useWindowSize } from '../../../shared/hooks';

// RDS Input/FormField/Textarea take `size` as a JS prop, not a CSS class, so it can't respond
// to a Tailwind breakpoint on its own. Mirrors ReferralForm's own pre-TRUSTED-96145 pattern
// (useWindowSize()?.width > 599 ? 'lg' : 'md'), since removed there but wanted here.
function useMatcherFieldSize(): 'md' | 'lg' {
  const { width } = useWindowSize();
  return width > 599 ? 'lg' : 'md';
}

export { useMatcherFieldSize };
